import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserAuth } from './AuthContext';
import { supabase } from '../supabaseClient';

const LogoutButton = () => {
  const { signOut, session } = UserAuth();
  const [loading, setLoading] = useState('');
  const [error, setError] = useState('');
  const [user, setUser] = useState(null);
  const [showButton, setShowButton] = useState(false);
  const navigate = useNavigate();

  // Handle logout
  const handleLogout = async () => {
    try {
      await signOut();
      setLoading('جاري تسجيل الخروج...');
    } catch (err) {
      setError('حدث خطأ أثناء تسجيل الخروج');
      console.error(err);
    }
  };

  // Listen to auth changes
  useEffect(() => {
    const checkUser = async () => {
      const currentSession = await session;
      if (currentSession?.user) {
        setUser(currentSession.user);
      } else {
        setUser(null);
      }
    };
    checkUser();

    const { data: listener } = supabase.auth.onAuthStateChange(
      (event, session) => {
        if (event === 'SIGNED_OUT') {
          setLoading('   تسجيل الدخول');
          navigate('/login');
        } else if (event === 'SIGNED_IN') {
          setLoading(' تسجيل الخروج ');
          setUser(session?.user);
        }
      }
    );

    return () => {
      listener.subscription.unsubscribe();
    };
  }, [session, navigate]);

  // if (!user) return null;

  return (
    <div
      className="fixed top-1/2 left-0 transform -translate-y-1/2 z-50"
      onMouseEnter={() => setShowButton(true)}
      onMouseLeave={() => setShowButton(false)}
    >
      <div
        className={`bg-white text-navy-700 px-4 py-2 rounded-r cursor-pointer transition-all duration-300 rtl text-right ${
          showButton ? 'w-48' : 'w-10'
        }`}
      >
        {error && <div className="text-yellow-300 text-sm mb-1">{error}</div>}
        {showButton && (
          <button onClick={handleLogout} className="w-full text-right">
            {loading || 'تسجيل الخروج'}
          </button>
        )}
        {!showButton && <span>NR</span>}
      </div>
    </div>
  );
};

export default LogoutButton;
